module.exports = __webpack_public_path__ + "img/img_2.cf7ea868.png";